<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="box">
          <div class="box-header b-b">
            <h5>Hourly Sales Report</h5>
            <small>Shows cumulative sales by hour</small>
          </div>
          <div class="box-tool">
            <ul class="nav">
              <li class="nav-item inline dropdown">
                <a 
                  data-toggle="dropdown" 
                  class="btn btn-default">Export</a>
                <div class="dropdown-menu dropdown-menu-scale pull-right">
                  <span class="dropdown-header">Export As</span>
                  <a 
                    class="dropdown-item" 
                    @click.prevent="exportAsFile('CSV')">CSV</a>
                  <a 
                    class="dropdown-item" 
                    @click.prevent="exportAsFile('PDF')">PDF</a>
                </div>
              </li>
            </ul>
          </div>
          <div class="box-body">
            <vue-apex-charts
              :options="chartOptions"
              :series="chartSeries"
              height="400px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from 'vuex';
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        VueApexCharts,
    },

    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            cumulativeSales: [],
            sales: [],
            xAxisSales: [],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),

        api() {
            return Laroute.route('franchise.report.hourly.getHourlySummary', {
                id: this.outlet,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        chartOptions() {
            return {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                    type: 'line',
                    stacked: false,
                },
                dataLabels: {
                    enabled: false,
                },
                colors: ['#0cc2aa', '#D10543'],
                stroke: {
                    width: [4, 4],
                },
                markers: {
                    size: 5,
                },

                xaxis: {
                    categories: this.xAxisSales,
                },

                yaxis: [
                    {
                        seriesName: 'Sales',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        title: {
                            text: 'Sales',
                        },
                        labels: {
                            formatter: value =>
                                `${this.Currency} ${numeral(value).format()}`,
                        },
                    },
                    {
                        opposite: true,
                        seriesName: 'Cumulative Sales',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        labels: {
                            formatter: value =>
                                `${this.Currency} ${numeral(value).format(
                                    '0,0',
                                )}`,
                        },
                    },
                ],

                tooltip: {
                    enabled: true,
                    shared: false,
                    intersect: true,
                    x: {
                        show: true,
                    },
                    marker: {
                        show: true,
                        shape: 'circle',
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 40,
                },
            };
        },

        chartSeries() {
            return [
                {
                    name: 'Sales',
                    type: 'column',
                    data: this.sales,
                },
                {
                    name: 'Cumulative Sales',
                    type: 'line',
                    data: this.cumulativeSales,
                },
            ];
        },
    },

    watch: {
        outlet() {
            this.getSummary();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getSummary();
        },
    },

    created() {},

    mounted() {
        this.getSummary();
        $(this.$el).tooltip({
            selector: '[data-toggle="tooltip"]',
        });
    },

    methods: {
        getSummary() {
            var that = this;
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };

            this.$http.get(this.api, { params: options }).then(response => {
                var data = response.data;

                that.xAxisSales = data.graph_data.total_sales.map(obj =>
                    moment(obj.date).format('HH'),
                );

                that.sales = data.graph_data.total_sales.map(obj => obj.total);

                that.cumulativeSales = data.graph_data.total_sales.map(
                    obj => obj.cumulative,
                );

                this.loading = false;
            });
        },

        exportAsFile(type) {
            let url = Laroute.route('franchise.report.hourly.exportGraphData', {
                id: this.outlet,
                type: type,
            });
            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };
            window.location.href = url + '?' + $.param(options);
        },

        formatNumber(number) {
            return numeral(number).format('0,0');
        },
    },
};
</script>
  
  <style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/hourly/vue_hourly.vue